import { AxiosResponse } from "axios";
import instance from "../instance";
import { CountryInterface } from "@/core/reatom/state/city";

export const getCountry = async (): Promise<CountryInterface[]> => {
  try {
    const res: AxiosResponse<{ items: CountryInterface[] }> =
      await instance.get(`/v1/countries`);
    return res.data.items;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
